export default {"src":"/_next/static/media/FLNG.5b91adf8.svg","height":18,"width":18};